import { createFileRoute, redirect } from "@tanstack/react-router";

// Moved to consignment-request.
export const Route = createFileRoute(
	"/admin/consignment/registrations/$id/detail",
)({
	validateSearch: (search: Record<string, unknown>): { tab?: string } =>
		typeof search.tab === "string" ? { tab: search.tab } : {},
	beforeLoad({ params, search }) {
		throw redirect({
			to: "/admin/consignment-request/$id/detail",
			params: { id: params.id },
			search,
			replace: true,
		});
	},
});
